/**
 * KidsMix Theme - Core JavaScript
 * Product variants, thumbnails, tabs, and utility functions
 */
(function () {
  'use strict';

  // --- Product Variant Selector ---
  function initProductVariants() {
    const variantJson = document.getElementById('productVariantsJson');
    if (!variantJson) return;

    var variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (e) {
      return;
    }

    const optionInputs = document.querySelectorAll('.product__option-value input');
    const variantIdInput = document.getElementById('productVariantId');
    const priceEl = document.getElementById('productPrice');
    const addBtn = document.getElementById('addToCartBtn');

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        // Collect selected options
        var selectedOptions = [];
        document.querySelectorAll('.product__option').forEach(function (optionGroup) {
          var checked = optionGroup.querySelector('input:checked');
          if (checked) selectedOptions.push(checked.value);
        });

        // Find matching variant
        var matchingVariant = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (matchingVariant) {
          variantIdInput.value = matchingVariant.id;

          // Update price
          if (priceEl) {
            var priceHtml = '';
            if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
              priceHtml = '<span class="product__price--sale">' + formatMoney(matchingVariant.price) + '</span>';
              priceHtml += '<span class="product__price--compare">' + formatMoney(matchingVariant.compare_at_price) + '</span>';
            } else {
              priceHtml = '<span>' + formatMoney(matchingVariant.price) + '</span>';
            }
            priceEl.innerHTML = priceHtml;
          }

          // Update button state
          if (addBtn) {
            if (matchingVariant.available) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.dataset.originalText || 'Add to Cart';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'Sold Out';
            }
          }

          // Update URL
          var url = new URL(window.location);
          url.searchParams.set('variant', matchingVariant.id);
          window.history.replaceState({}, '', url);

          // Update main image if variant has image
          if (matchingVariant.featured_image) {
            var mainImg = document.getElementById('mainProductImage');
            if (mainImg) {
              mainImg.src = matchingVariant.featured_image.src;
              mainImg.alt = matchingVariant.featured_image.alt || '';
            }
          }
        }
      });
    });
  }

  // --- Product Image Thumbnails ---
  function initProductThumbnails() {
    const thumbnails = document.querySelectorAll('.product__thumbnail');
    if (!thumbnails.length) return;

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        var mainImg = document.getElementById('mainProductImage');
        if (mainImg) {
          mainImg.src = thumb.dataset.imageUrl;
          mainImg.alt = thumb.dataset.imageAlt || '';
        }
      });
    });
  }

  // --- Tabs ---
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabContainer) {
      var buttons = tabContainer.querySelectorAll('.tab-btn');
      var contents = tabContainer.querySelectorAll('.tab-content');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.target;

          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          contents.forEach(function (c) { c.classList.remove('is-active'); });

          btn.classList.add('is-active');
          var targetContent = tabContainer.querySelector('#' + target);
          if (targetContent) targetContent.classList.add('is-active');
        });
      });
    });
  }

  // --- Countdown Timer ---
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var endDate = new Date(el.dataset.countdown).getTime();
      if (isNaN(endDate)) return;

      function updateCountdown() {
        var now = new Date().getTime();
        var distance = endDate - now;

        if (distance < 0) {
          el.innerHTML = '<p>Süre Doldu</p>';
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        el.innerHTML =
          '<div class="countdown__block"><span class="countdown__number">' + days + '</span><span class="countdown__label">Days</span></div>' +
          '<div class="countdown__block"><span class="countdown__number">' + pad(hours) + '</span><span class="countdown__label">Hours</span></div>' +
          '<div class="countdown__block"><span class="countdown__number">' + pad(minutes) + '</span><span class="countdown__label">Min</span></div>' +
          '<div class="countdown__block"><span class="countdown__number">' + pad(seconds) + '</span><span class="countdown__label">Sec</span></div>';

        setTimeout(updateCountdown, 1000);
      }

      updateCountdown();
    });
  }

  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  // --- Format Money ---
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (parseInt(cents) / 100).toFixed(2);
    return value.replace('.', ',') + '₺';
  }

  // --- Lazy Load Images ---
  function initLazyLoad() {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          }
        });
      }, { rootMargin: '200px' });

      document.querySelectorAll('img[data-src]').forEach(function (img) {
        observer.observe(img);
      });
    }
  }

  // --- Initialize on DOM Ready ---
  document.addEventListener('DOMContentLoaded', function () {
    initProductVariants();
    initProductThumbnails();
    initTabs();
    initCountdown();
    initLazyLoad();
  });
})();
